// ENIAC Coaching Centre - Mock Data

export const instituteInfo = {
  name: "ENIAC",
  fullName: "ENIAC Coaching Centre",
  tagline: "Shaping Futures, One Student at a Time",
  description: "A renowned coaching centre in Bardhaman providing quality education by experienced teachers for CBSE, ICSE & WBBSE boards.",
  phone: "+91 73648 96657",
  email: "eniaccoaching@gmail.com",
  address: "Perbirhata, Bardhaman, West Bengal 713103, India",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3643.5!2d87.86!3d23.25!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f849cdc2373849%3A0xfe741e56de87c0c8!2sEniac%20Computer%20and%20Coaching%20Center!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin",
  googleRating: 4.4,
  totalReviews: 29,
  foundedYear: 1998,
  facebook: "https://www.facebook.com/p/ENIAC-Coaching-Centre-61550694407271/",
  hours: {
    morning: "7:00 AM - 2:00 PM",
    evening: "4:00 PM - 10:00 PM"
  }
};

export const stats = [
  { id: 1, value: 10000, suffix: "+", label: "Students Enrolled" },
  { id: 2, value: 25, suffix: "+", label: "Expert Teachers" },
  { id: 3, value: 25, suffix: "+", label: "Years of Excellence" },
  { id: 4, value: 96, suffix: "%", label: "Success Rate" }
];

export const boards = [
  {
    id: 1,
    name: "CBSE",
    fullName: "Central Board of Secondary Education",
    description: "Comprehensive coaching for CBSE curriculum from Class I to X with focus on NCERT-based learning, competitive exam preparation, and conceptual clarity.",
    classes: "Class I - X",
    icon: "BookOpen",
    color: "teal",
    highlights: ["NCERT-aligned curriculum", "Regular assessments", "Doubt clearing sessions", "Competitive exam prep"]
  },
  {
    id: 2,
    name: "ICSE",
    fullName: "Indian Certificate of Secondary Education",
    description: "Expert guidance for ICSE board students with detailed subject coverage, practical learning approaches, and emphasis on analytical thinking.",
    classes: "Class I - X",
    icon: "GraduationCap",
    color: "amber",
    highlights: ["In-depth subject coverage", "Practical learning", "Critical thinking focus", "Project-based assessments"]
  },
  {
    id: 3,
    name: "WBBSE",
    fullName: "West Bengal Board of Secondary Education",
    description: "Specialized coaching for West Bengal board students with focus on Madhyamik preparation, Bengali & English medium support, and state-level exam readiness.",
    classes: "KG - Class X",
    icon: "School",
    color: "rose",
    highlights: ["Madhyamik preparation", "Bengali & English medium", "State curriculum expertise", "Board exam strategies"]
  }
];

export const subjects = [
  { id: 1, name: "Mathematics", icon: "Calculator", description: "Building strong foundations in algebra, geometry, arithmetic & more" },
  { id: 2, name: "Science", icon: "FlaskConical", description: "Physics, Chemistry & Biology with hands-on experiments" },
  { id: 3, name: "English", icon: "Languages", description: "Grammar, literature, creative writing & communication" },
  { id: 4, name: "Bengali", icon: "BookText", description: "Bengali language, literature & comprehensive grammar" },
  { id: 5, name: "Hindi", icon: "BookMarked", description: "Hindi language proficiency and literature appreciation" },
  { id: 6, name: "Social Science", icon: "Globe", description: "History, Geography, Civics & Economics fundamentals" },
  { id: 7, name: "Computer Science", icon: "Monitor", description: "Basic programming, digital literacy & computer fundamentals" },
  { id: 8, name: "Physics, Chemistry, Biology", icon: "Atom", description: "Advanced physics and chemistry for higher classes" }
];

export const features = [
  {
    id: 1,
    title: "Experienced Faculty",
    description: "Our teachers bring years of expertise and passion for education, ensuring every student receives personalized attention.",
    icon: "Users"
  },
  {
    id: 2,
    title: "Small Batch Sizes",
    description: "Limited students per batch ensures individual attention, better doubt resolution, and interactive learning sessions.",
    icon: "UserCheck"
  },
  {
    id: 3,
    title: "Regular Assessments",
    description: "Weekly tests, monthly evaluations, and mock exams to track progress and identify areas for improvement.",
    icon: "ClipboardCheck"
  },
  {
    id: 4,
    title: "Study Materials",
    description: "Comprehensive notes, practice worksheets, and curated question banks aligned with board exam patterns.",
    icon: "FileText"
  },
  {
    id: 5,
    title: "Doubt Clearing Sessions",
    description: "Dedicated extra sessions for doubt resolution, ensuring no student is left behind in understanding concepts.",
    icon: "HelpCircle"
  },
  {
    id: 6,
    title: "Parent-Teacher Meetings",
    description: "Regular PTMs to discuss student progress, academic performance, and collaborative growth strategies.",
    icon: "Handshake"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarbajit Singha Roy",
    role: "Parent",
    text: "Good coaching centre along with specialised teachers for every subject. My child's grades have improved significantly since joining ENIAC.",
    rating: 5
  },
  {
    id: 2,
    name: "Avijit Koley",
    role: "Student",
    text: "Best academic coaching institute in Burdwan Town. The teachers are very supportive and the study materials are excellent.",
    rating: 5
  },
  {
    id: 3,
    name: "Sumanta Chatterjee",
    role: "Parent",
    text: "Excellent educational institution. The way they handle each student individually is commendable. Highly recommended for all boards.",
    rating: 5
  },
  {
    id: 4,
    name: "Dipean Mallick",
    role: "Student",
    text: "Amazing experience at ENIAC! The faculty is extremely knowledgeable and they make complex topics easy to understand. Scored 95% in boards!",
    rating: 5
  },
  {
    id: 5,
    name: "Rina Das",
    role: "Parent",
    text: "My daughter has been going to ENIAC for 2 years now. The improvement in her confidence and academic performance is remarkable.",
    rating: 4
  },
  {
    id: 6,
    name: "Arjun Banerjee",
    role: "Student",
    text: "The doubt clearing sessions are the best part. No matter how many times I ask, teachers patiently explain until I understand completely.",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What boards do you offer coaching for?",
    answer: "We offer comprehensive coaching for CBSE, ICSE, and WBBSE (West Bengal Board) from KG to Class X for all subjects."
  },
  {
    id: 2,
    question: "What are the batch timings?",
    answer: "We have flexible batch timings - Morning batches from 7:00 AM to 10:00 AM and Evening batches from 4:00 PM to 8:00 PM. Specific timings vary by class."
  },
  {
    id: 3,
    question: "Do you provide study materials?",
    answer: "Yes, we provide comprehensive study materials including notes, practice worksheets, previous year question papers, and specially curated question banks for each subject."
  },
  {
    id: 4,
    question: "What is the batch size?",
    answer: "We maintain small batch sizes of 15-20 students to ensure personalized attention and effective doubt resolution for every student."
  },
  {
    id: 5,
    question: "How can I enroll my child?",
    answer: "You can visit our centre at Perbirhata, Bardhaman or call us at +91 73648 96657. You can also fill the contact form on our website and we'll get back to you."
  },
  {
    id: 6,
    question: "Do you conduct mock tests and assessments?",
    answer: "Yes, we conduct weekly chapter-wise tests, monthly comprehensive tests, and full-length mock exams before board examinations to ensure thorough preparation."
  }
];


export const images = {
  classroom: "https://images.unsplash.com/photo-1509062522246-3755977927d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxzdHVkZW50cyUyMGNsYXNzcm9vbXxlbnwwfHx8fDE3NzEwNDMxNzB8MA&ixlib=rb-4.1.0&q=85",
  teacher: "https://images.unsplash.com/photo-1524178232363-1fb2b075b655?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHx0ZWFjaGVyJTIwdGVhY2hpbmd8ZW58MHx8fHwxNzcxMDQzMTc1fDA&ixlib=rb-4.1.0&q=85",
  library: "https://images.unsplash.com/photo-1730234030296-4d1c4037a872?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwzfHxzdHVkZW50cyUyMGJvb2tzfGVufDB8fHx8MTc3MTA0MzE3OXww&ixlib=rb-4.1.0&q=85",
  success: "https://images.unsplash.com/photo-1628887919785-ae536631cb76?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHw0fHxncmFkdWF0aW9uJTIwc3VjY2Vzc3xlbnwwfHx8fDE3NzEwNDMxOTB8MA&ixlib=rb-4.1.0&q=85"
};

export const navLinks = [
  { id: 1, label: "Home", href: "#home" },
  { id: 2, label: "About", href: "#about" },
  { id: 3, label: "Programs", href: "#programs" },
  { id: 4, label: "Subjects", href: "#subjects" },
  { id: 5, label: "Feedbacks", href: "#feedbacks" },
  { id: 6, label: "FAQ", href: "#faq" },
  { id: 7, label: "Contact", href: "#contact" }
];
